
import React from "react";

import { Duration } from "luxon";

import logo from './img/TA-Logo-TS-banner_copy.png';

import './MapOverlayWidget.css';

class MapOverlayWidget extends React.PureComponent {
    constructor(props) {
        super(props);

        this.injuries = 0;
        this.fatalities = 0;
        this.ntors = 0;
    }

    componentDidMount() {
        this.props['setscreenshotfunc'](this.screenshot.bind(this), 'overlay');
    }

    screenshot() {
        const ta_logo_promise = new Promise((resolve, reject) => {
            let img = new Image();
            img.onload = () => resolve(img);
            img.src = logo;
        });
        
        const mapbox_logo_promise = new Promise((resolve, reject) => {
            let img = new Image();
            img.onload = () => resolve(img);

            const a = document.querySelector('a.mapboxgl-ctrl-logo');
            const style = window.getComputedStyle(a, false);
            const dataURL = style.backgroundImage.slice(5, -2);

            img.src = dataURL;
        });

        return Promise.allSettled([ta_logo_promise, mapbox_logo_promise]).then(results => {
            const logo_img = results[0]['value'];
            const mapbox_logo_img = results[1]['value'];

            const dpr = window.devicePixelRatio || 1;
            const rect = document.getElementsByClassName('overlay')[0].getBoundingClientRect();

            let canvas = document.createElement('canvas');
            canvas.width = rect.width * dpr;
            canvas.height = rect.height * dpr;

            let ctx = canvas.getContext('2d');

            // This is gonna get stoopid
            const header = document.getElementById('map-header');
            const header_rect = header.getBoundingClientRect();
            const header_style = window.getComputedStyle(header);
            const background_color = header_style['backgroundColor'];

            // Draw header background
            ctx.beginPath();
            ctx.fillStyle = background_color;
            ctx.rect(header_rect['x'] * dpr, header_rect['y'] * dpr, header_rect['width'] * dpr, header_rect['height'] * dpr);
            ctx.fill();

            // Create statistics text
            ctx.fillStyle = '#000000';
            ctx.font = (16 * dpr) + 'px Trebuchet MS';
            ctx.textAlign = 'right';
            ctx.textBaseline = 'top';

            ctx.fillText('Number of Tornadoes: ' + this.ntors, (header_rect['width'] - 8) * dpr, 2 * dpr);
            ctx.fillText('Fatalities: ' + this.fatalities + '    Injuries: ' + this.injuries, (header_rect['width'] - 8) * dpr, 21 * dpr);

            // Draw TA logo
            const logo_width = logo_img.width;
            const logo_height = logo_img.height;
            const logo_aspect = logo_width / logo_height;

            ctx.drawImage(logo_img, 0, 0, 41 * dpr * logo_aspect, 41 * dpr);

            // Create date and filter header text
            const [date_header_str, filter_str] = this._createMapHeaders();

            ctx.textAlign = 'left';
            ctx.fillText(date_header_str, 140 * dpr, 2 * dpr);
            ctx.fillText(filter_str, 140 * dpr, 21 * dpr);

            // Add mapbox credits (most of this stolen from https://github.com/mapbox/mapbox-gl-js/pull/6518/files)
            ctx.drawImage(mapbox_logo_img, 3 * dpr, canvas.height - (mapbox_logo_img.height + 4) * dpr, 
                          mapbox_logo_img.width * dpr, mapbox_logo_img.height * dpr);

            let text = '© Mapbox © OpenStreetMap';
            if (canvas.width < 300) text = '© OSM';
            const fontsize = 14;
            const height = fontsize + 6;
            const width = (text.length + 3) / fontsize * 100;

            ctx.fillStyle = 'rgba(255,255,255,0.4)';
            ctx.fillRect(canvas.width - width * dpr, canvas.height - height * dpr, width * dpr, height * dpr);

            ctx.font = (fontsize * dpr) + 'px Arial';
            ctx.fillStyle = 'black';
            ctx.textAlign = 'left';
            ctx.textBaseline = 'bottom';
            ctx.fillText(text, canvas.width - (width - 3) * dpr, canvas.height - 3 * dpr);

            return canvas.toDataURL();
        });
    }

    _createMapHeaders() {
        const filters = Object.values(Object.fromEntries(Object.entries(this.props['filters']).filter(([k, v]) => k != 'partition')));
        const filter_str = filters.map(filt => filt.toHeaderString()).join(', ');
        const partition_filter_str = this.props['filters']['partition'] === undefined ? '' : this.props['filters']['partition'].toHeaderString() + ' ';

        const intv_string_parts = this.props['interval'].toString(true);

        return [partition_filter_str + 'Tornadoes ' + intv_string_parts['preposition'] + ' ' + intv_string_parts['string'], filter_str];
    }

    render() {
        let statistics_header = "";
        if (this.props['tor_coll'] !== null) {
            this.ntors = this.props['tor_coll'].getNTornadoes([this.props['interval']])[0]['count'];
            this.injuries = 0;
            this.fatalities = 0;
            if (this.ntors > 0) {
                this.injuries = this.props['tor_coll'].getPropertyValues('injuries', this.props['interval'])['injuries'].reduce((a, b) => a + b);
                this.fatalities = this.props['tor_coll'].getPropertyValues('fatalities', this.props['interval'])['fatalities'].reduce((a, b) => a + b);
            }

            statistics_header = (
                <div id='statistics-header'>
                    <div>
                        <div>Number of Tornadoes: {this.ntors}</div>
                    </div>
                    <div>
                        <div>Injuries: {this.injuries}</div>
                        <div>Fatalities: {this.fatalities}</div>
                    </div>
                </div>
            );
        }

        const [date_header_str, filter_str] = this._createMapHeaders();

        return (
            <div className='overlay'>
                <div id='map-header'>
                    <div id='logo'><a href='https://tornadoarchive.com/home' target='_blank'><img src={logo}></img></a></div>
                    <div id='date-header'>
                        <div>{date_header_str}</div>
                        <div>{filter_str}</div>
                    </div>
                    {statistics_header}
                </div>
            </div>
        );
    }
}

export default MapOverlayWidget;